// extracted by mini-css-extract-plugin
module.exports = {"root":"PlpLayout_root__wlzdK","sidebar":"PlpLayout_sidebar__BDqDJ","main":"PlpLayout_main__Qu6wm"};